import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { resolveSignedInRedirect, resolveWebAppRedirect } from './webAppRedirect';

const webAppTarget =
  resolveWebAppRedirect(window.location) ?? resolveSignedInRedirect(window.location, document.cookie);
if (webAppTarget) window.location.replace(webAppTarget);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
